// src/colors/palette.js
// Add, remove, or reorder as you like.
// value is any CSS color, hex recommended.
export const palette = [
  { name: "Natural white", value: "#FFFFFFF2" },
  { name: "Ice Blue", value: "#A3D8E1" },
  { name: "Scarlet Red", value: "#DE4343" },
  { name: "Charcoal", value: "#000000" },
  { name: "Ocean blue", value: "#0078BF" },
  { name: "Forest green", value: "#61C680" },
  { name: "Sunset orange", value: "#F99963" },
  { name: "Soft pink", value: "#E8AFCF" },
  { name: "Lavender purple", value: "#AE96D4" },
    { name: "Sunny yellow", value: "#F7D959" },
    { name: "Latte Brown", value: "#D3B7A7" },
];
